export var LivenessType;
(function (LivenessType) {
    LivenessType[LivenessType["None"] = 0] = "None";
    LivenessType[LivenessType["ByDescriptor"] = 1] = "ByDescriptor";
    LivenessType[LivenessType["ByPhoto"] = 2] = "ByPhoto";
})(LivenessType || (LivenessType = {}));
//# sourceMappingURL=definitions.js.map